import { Platform, Orientation } from "consts";

export const ContainerWidth = {
  [Platform.WEB]: {
    [Orientation.PORTRAIT]: "50%",
    [Orientation.LANDSCAPE]: "26%",
  },
  [Platform.TAB]: {
    [Orientation.LANDSCAPE]: "60%",
    [Orientation.PORTRAIT]: "70%",
  },
};

export const ContainerSpace = {
  [Platform.TAB]: {
    [Orientation.LANDSCAPE]: "space-evenly",
    [Orientation.PORTRAIT]: "space-evenly",
  },
};

export const GenderButtonWidth = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: width => (width - 460) / 2,
    [Orientation.LANDSCAPE]: "170",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: width => (width - 90) / 2,
    [Orientation.LANDSCAPE]: width => (width - 350) / 2,
  },
};

export const GenderButtonHeight = {
  [Platform.TAB]: {
    [Orientation.PORTRAIT]: "145",
  },
  [Platform.AND]: {
    [Orientation.PORTRAIT]: "145",
  },
};
